export function checkIfVideoPlayingOnMobile() {
    const video = document.getElementById('videoid');
    let counter = 0;

    if (window.innerWidth < 800 && video !== null) {
        checkIfPlaying();
    }

    // Checks if the video is playing, if not checks again up to 3 times
    function checkIfPlaying() {
        const videoWrapper = document.querySelector('.js-video-wrapper');
        
        // Video is playing
        if (!video.paused) {
            videoWrapper.classList.add('has-autoplay');
        } else {
            // Video is not playing, check a few times
            if (counter <= 5) {
                setTimeout(function() {
                    counter++;
                    checkIfPlaying();
                }, 100);
            } else {
                videoWrapper.classList.add('no-autoplay');
            }
        }
    }
}

export function videoInit() {
    checkIfVideoPlayingOnMobile();
}